





























































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import AccountSettingsService from '@/profile/account-settings/services/account-settings.service';
import Rep from '@/_shared/entities/rep/rep.entity';
import LogService from '@/_shared/services/log/log.service';

@Component
export default class AccountSettingsView extends Vue {
  private hasFinishedLoading = false;

  private team_stream_flag = false;

  private holding_tank_in_use = false;

  private recognition_flag = false;

  private showPassword = false;
  private currentPassword = '';
  private newPassword = '';
  private newPasswordErrorMessage = '';
  private confirmPassword = '';
  private confirmPasswordErrorMessage = '';

  get rep(): Rep { return this.$store.state.RepStore.rep; }

  get passwordPlaceholder(): string {
    return this.$t('PROFILE.CHANGE_PASSWORD.PASSWORD_PLACEHOLDER').toString();
  }

  get newPasswordPlaceholder(): string {
    return this.$t('PROFILE.CHANGE_PASSWORD.NEW_PASSWORD_PLACEHOLDER').toString();
  }

  get confirmPasswordPlaceholder(): string {
    return this.$t('PROFILE.CHANGE_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER').toString();
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  private async save(): Promise<void> {
    await this.$store.dispatch('showLoading');
    /* eslint-disable @typescript-eslint/camelcase */
    await AccountSettingsService.setPrivacySettings(this.rep.did, {
      recognition_flag: this.recognition_flag,
      team_stream_flag: this.team_stream_flag,
    });

    await AccountSettingsService.setHoldingTankSettings(this.rep.did,
      { holding_tank_in_use: this.holding_tank_in_use });

    if (this.newPasswordState && this.confirmPasswordState) {
      await this.changePassword();
    }

    await this.$store.dispatch('hideLoading');
    this.showSuccessMessage();
    /* eslint-enable @typescript-eslint/camelcase */
  }

  get newPasswordState(): boolean | null {
    if (this.newPassword === '') {
      return null;
    }

    this.newPasswordErrorMessage = this.$t('PROFILE.CHANGE_PASSWORD.ERROR_FORMAT').toString();
    return AccountSettingsService.isPasswordValid(this.newPassword);
  }

  get confirmPasswordState(): boolean | null {
    if (this.confirmPassword === '') {
      return null;
    }

    this.confirmPasswordErrorMessage = this.$t('PROFILE.CHANGE_PASSWORD.ERROR_MATCH').toString();
    return (this.newPassword === this.confirmPassword);
  }

  private async changePassword() {
    await AccountSettingsService.changePassword(this.rep.did, this.currentPassword,
      this.newPassword)
      .catch(() => {
        this.showErrorMessage();
      });
  }

  private async created(): Promise<void> {
    await this.$store.dispatch('showLoading');
    const privacyData = await AccountSettingsService.getPrivacySettings(this.rep.did);
    const holdingTankData = await AccountSettingsService.getHoldingTankSettings(this.rep.did);
    /* eslint-disable @typescript-eslint/camelcase */
    const { recognition_flag, team_stream_flag } = privacyData;
    this.recognition_flag = recognition_flag;
    this.team_stream_flag = team_stream_flag;

    const { holding_tank_in_use } = holdingTankData;
    this.holding_tank_in_use = holding_tank_in_use;
    /* eslint-enable @typescript-eslint/camelcase */
    this.$emit('done-loading');
    this.hasFinishedLoading = true;
    await this.$store.dispatch('hideLoading');
  }

  private showSuccessMessage(): void {
    LogService.toastrSuccess(
      this.$t('PROFILE.TOAST_SUCCESS_MESSAGE').toString(),
      this.$t('PROFILE.TOAST_SUCCESS_HEADER').toString(),
    );
  }

  private showErrorMessage(): void {
    LogService.toastrError(
      this.$t('PROFILE.TOAST_ERROR_MESSAGE').toString(),
      this.$t('PROFILE.TOAST_ERROR_HEADER').toString(),
    );
  }
}
